export const rhfToFormData = (data: Record<string, string>): FormData => {
  const d = new FormData()

  for (const key in data) {
    if (key === 'field') {
      d.append(key, data[key][1])
    } else {
      d.append(key, data[key])
    }
  }
  return d
}
